<template>
    <div>
        <div class="mb-2 d-lg-flex d-sm-flex d-xl-flex justify-content-between align-items-center">
            <h4 class="mt-2 C-head mr-3 text-dark fw-300">
                <i class="fa fa-th-list mr-3" aria-hidden="true"></i>Leave history {{ ViewType ? 'Fiscal year' : 'Present' }}
            </h4>
        </div>
        <div v-if="ViewType">
            <div v-if="blankAll.length == 1">
                <h5 class="C-event mt-0 mb-0">
                    <i class="text-center text-muted">I can't find the record for submitting your fiscal year</i>
                </h5>
            </div> 
            <div v-else>
                <div v-for="(itemE, indexE) in eventLeave" :key="'event'+ indexE" class="icon-v-hover">
                    <div v-if="itemE.dataLeave.length !== 0">
                        <div v-for="(itemD, indexD) in itemE.dataLeave" :key="'detail'+ indexD">
                            <b-alert class="mt-1 mb-2 border-cus-leave leave-app" show variant="danger-cus">
                                <div class="d-lg-flex d-sm-flex d-xl-flex justify-content-between align-items-center">
                                    <span class="mt-2 text-capitalize C-event size-type text-dark">
                                        <i class="fa fa-tags mr-2" aria-hidden="true"></i><strong>{{ itemD.absence_type }}</strong> ( {{ itemD.absence_amount }} Days. )
                                    </span>
                                    <span class="mt-2 C-event text-dark">
                                        <i><strong v-html="setStautus(itemD.status)"></strong> , {{ moment(itemD.updated_at).format('LLL') }}</i>
                                    </span>
                                </div>
                                <p class="C-event mt-2 mb-1 text-dark">
                                    <strong>
                                        <i class="fa fa-calendar-times-o mr-2" aria-hidden="true"></i>
                                    </strong>
                                    {{ moment(itemD.start_date).format('MMMM Do YYYY') }} <strong>To</strong> {{ moment(itemD.end_date).format('MMMM Do YYYY') }}
                                </p>
                                <p v-if="itemD.remark !== null && itemD.remark !== '' && itemD.remark !== 'null'" class="C-event mt-1 mb-1 text-dark">
                                    <strong><i class="fa fa-sticky-note mr-2" aria-hidden="true"></i>Remark : </strong>
                                    {{ itemD.remark }}
                                </p>
                            </b-alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: { 
            'full-calendar': require('vue-fullcalendar')
        },
        props: {
            viewListLeaveYear: {
                type: String,
                required: true,
                default: () => ''
            },
            eventLeave: {
                type: Array,
                required: true,
                default: () => []
            },
            blankAll : {
                type: Array,
                required: true,
                default: () => []
            },
        },
        computed: {},
        data(){
            return {
                arrTemp:[],
                listToggle: false,
                calendarToggle: false,
                ViewType:true,
                attributes: [
                    // {
                    //     key: 1,
                    //     bar: '',
                    //     customData: {
                    //         type: 'SICK',
                    //         amount: '6 Days.',
                    //         class: 'bg-danger text-white',
                    //     },
                    //     dates: {
                    //         start : '2020-09-20',
                    //         end : '2020-09-22',
                    //     }
                    // },
                    // {
                    //     key: 2,
                    //     bar: 'blue',
                    //     customData: {
                    //         type: 'Event 1',
                    //         amount: '',
                    //         class: '',
                    //     },
                    //     dates: {
                    //         start : new Date(2020, 8, 15),
                    //         end : new Date(2020, 8, 25),
                    //     }
                    // },
                ],
            }
        },
        watch: {},
        mounted () {
            this.listToggle = true
        },
        methods: {
            ChangeView(typeView){
                if(typeView === 'list'){
                    this.ViewType = true
                    this.listToggle = true
                    this.calendarToggle = false
                }else{
                    this.listToggle = false
                    this.calendarToggle = true
                    this.ViewType = false
                }
            },
            setStautus(statusChk){
                let htmlStatus = ''
                if(statusChk === 'wait'){
                    htmlStatus = `<span class="C-event text-warning">Wait</span>`
                }
                else if(statusChk === 'reject'){
                    htmlStatus = `<span class="C-event text-danger">Reject</span>`
                }
                else if(statusChk === 'approve'){
                    htmlStatus = `<span class="C-event text-success">Approved</span>`
                }
                else if(statusChk === 'cancel'){
                    htmlStatus = `<span class="C-event">Cancel</span>`
                }
                return htmlStatus
            },
        }
    }
</script>

<style lang='css'>
    .alert-danger-cus {
        background-color: #f9f7f7;
        color: #000;
    }
    .C-head{ font-family: 'Baloo Tamma 2', cursive; }
    .C-event{ font-family: 'Baloo Tamma 2', cursive; }
    .C-small{ font-family: 'Baloo Tamma 2', cursive; font-size: 1.75rem; }
    .f-c2{ font-size: 2rem; }
    .font-calendar{ font-family: 'Baloo Tamma 2', cursive; font-size: .95rem; font-weight: 500; }
    .leave-app{ /* transition: transform 1s; */}
    .leave-app:hover { 
        /* transform :scale(1.1);
        margin-left: 55px;
        margin-right: 60px; */
    }
    .icon-v-hover #view-icon{
        visibility:hidden;
    }
    .icon-v-hover:hover #view-icon{
        visibility:visible;
    }
    .size-type{ font-size: 1.2rem; }
    .border-cus-leave{ border-left: 2px solid #f73131; }
    .fw-300{ font-weight: 300; }
    /* v-calendar */
    .vc-day:not(.on-right) {
        border-right: 1px solid rgb(226, 232, 240);
    }
    .vc-day:not(.on-left) {
        border-right: 1px solid rgb(226, 232, 240);
    }
    .vc-day:not(.on-bottom) {
        border-bottom: 1px solid rgb(226, 232, 240);
    }
    .vc-text-sm {
        font-size: 14px !important;
    }
    .vc-weekday{ font-family: 'Baloo Tamma 2', cursive; }
    .vc-title-layout{ font-family: 'Baloo Tamma 2', cursive; }
</style>

<style lang="scss" scoped>
    @media only screen and (max-width: 600px) {
        .hidden-view {   
            display:none;
        }
        .right-con{ text-align: right; }
    }
</style>